import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// @mui
import { Alert, Card, Container, Grid, CardContent, Typography, Box } from '@mui/material';

// ----------------------------------------------------------------------

// Хелпер
const getYouTubeID = (url) => {
  if (!url) return '';
  if (!url.includes('/') && url.length === 11) return url;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : url;
};

export default function IntroStudPage() {
  const [videos, setVideos] = useState([]);

  useEffect(() => {
    api.get(`video-api?filter[type]=1&filter[course_id]=${profile.data.course_id ? profile.data.course_id : 0}`)
      .then((result) => {
        setVideos(result);
      })
      .catch(() => {
        setVideos([]);
      });
  }, [])

  return (
    <>
      <Helmet>
        <title> Правила | Lala English </title>
      </Helmet>

      <Alert severity="error" sx={{ mb: 5, pl: 3 }}>Сторінка з інформацією про платформу.</Alert>
      <Container>

        <Grid container spacing={3}>
          {!videos.length ? <Typography variant="body2" sx={{ p: 3.5 }}>Ще немає відео</Typography> : null}
          {videos.map((video) => (
            // xs={12} - щоб картка була на всю ширину (одна в рядку)
            <Grid key={video.id} item xs={12}>
              <Card sx={{ 
                position: 'relative', 
                display: 'flex', 
                // На мобільних - колонка (відео зверху), на десктопі - рядок (відео зліва)
                flexDirection: { xs: 'column', md: 'row' },
                overflow: 'hidden'
              }}>
                
                {/* Контейнер для відео */}
                <Box sx={{ 
                  width: { xs: '100%', md: '320px' }, // Фіксована ширина для вертикального відео на десктопі
                  flexShrink: 0,
                  bgcolor: 'black' // Чорний фон, якщо відео має інші пропорції
                }}>
                  {/* Пропорція 9:16 (Вертикальне відео) -> 177.77% */}
                  {/* Якщо треба квадратне - ставте 100%, якщо горизонтальне - 56.25% */}
                  <div style={{ position: 'relative', paddingBottom: '177.77%', height: 0, overflow: 'hidden' }}>
                    <iframe
                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                      src={`https://www.youtube.com/embed/${getYouTubeID(video.url)}`}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                    />
                  </div>
                </Box>

                {/* Контент справа */}
                <CardContent sx={{ flexGrow: 1, p: 4 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {video.title}
                  </Typography>
                  
                  {video.text ? (
                    <Typography variant="body1" sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}>
                      {video.text}
                    </Typography>
                  ) : null}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
}